/* sc-navigation.js
 * SHRYMP COMMERCE NAVIGATION LOGIC
 */
(function () {
  "use strict";

  if (window.customElements && window.customElements.get("sc-nav-drawer"))
    return;

  var FOCUSABLE = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "summary",
    '[tabindex]:not([tabindex="-1"])',
  ].join(",");

  var instances = [];

  function getActiveInstance() {
    return (
      instances.find(function (i) {
        return i.isOpen;
      }) || null
    );
  }

  function ScNavDrawer() {
    return Reflect.construct(HTMLElement, [], ScNavDrawer);
  }

  ScNavDrawer.prototype = Object.create(HTMLElement.prototype);
  ScNavDrawer.prototype.constructor = ScNavDrawer;
  Object.setPrototypeOf(ScNavDrawer, HTMLElement);

  ScNavDrawer.prototype.connectedCallback = function () {
    if (this._initialized) return;
    this._initialized = true;
    this.isOpen = false;

    this.drawer = this.querySelector(".sc-nav__drawer");
    this.overlay = this.querySelector(".sc-nav__overlay");
    this.closers = this.querySelectorAll("[data-sc-nav-close]");
    this.scrollEl = this.querySelector("[data-sc-nav-scroll]");

    var self = this;
    this.closers.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        self.close();
      });
      btn.removeAttribute("hidden");
    });

    this._onKeydown = this._onKeydown.bind(this);

    this._bindTriggers();
    this._bindBubbleScroll();
    document.body.classList.add("sc-nav-installed");

    instances.push(this);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:section:select", function (event) {
        if (event.detail.sectionId === self.dataset.sectionId) self.open();
      });
      document.addEventListener("shopify:section:deselect", function (event) {
        if (event.detail.sectionId === self.dataset.sectionId) self.close();
      });
      document.addEventListener("shopify:block:select", function (event) {
        if (self.contains(event.target)) self.open();
      });
    }
  };

  ScNavDrawer.prototype.disconnectedCallback = function () {
    var idx = instances.indexOf(this);
    if (idx > -1) instances.splice(idx, 1);
    document.removeEventListener("keydown", this._onKeydown);
  };

  ScNavDrawer.prototype._bindTriggers = function () {
    var self = this;
    var selector =
      this.dataset.triggerSelector || ".header__icon--menu, [data-sc-nav-open]";

    document.addEventListener(
      "click",
      function (event) {
        var target = event.target.closest(selector);
        if (!target) return;
        if (self.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        var details = target.closest("details");
        if (details && details.open) details.open = false;
        self.open(target);
      },
      true,
    );
  };

  ScNavDrawer.prototype._bindBubbleScroll = function () {
    var wrap = this.querySelector("[data-sc-bubble-wrap]");
    if (!wrap) return;
    var track = wrap.querySelector("[data-sc-bubble-track]");
    var hint = wrap.querySelector("[data-sc-bubble-scroll-hint]");
    if (!track) return;

    var update = function () {
      var canScroll = track.scrollWidth - track.clientWidth > 4;
      var atEnd =
        !canScroll ||
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      wrap.dataset.scAtEnd = atEnd ? "true" : "false";
      wrap.dataset.scCanScroll = canScroll ? "true" : "false";
    };

    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    if (hint) {
      hint.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var step = Math.max(track.clientWidth * 0.7, 180);
        track.scrollBy({ left: step, behavior: "smooth" });
      });
    }

    // Layout is 0×0 while drawer is hidden — recompute after open.
    this._updateBubbleScroll = update;
    update();
  };

  ScNavDrawer.prototype.open = function (trigger) {
    if (this.isOpen) return;
    instances.forEach(function (other) {
      if (other !== this && other.isOpen) other.close();
    }, this);

    this.isOpen = true;
    this._lastFocus = trigger || document.activeElement;
    this.classList.add("is-open");
    this.drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("sc-nav-open", "sc-nav-active");
    document.addEventListener("keydown", this._onKeydown);

    if (this.scrollEl) this.scrollEl.scrollTop = 0;

    var self = this;
    window.requestAnimationFrame(function () {
      var focusable = self.drawer.querySelector(FOCUSABLE);
      if (focusable) focusable.focus({ preventScroll: true });
      if (self._updateBubbleScroll) self._updateBubbleScroll();
    });
  };

  ScNavDrawer.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.classList.remove("is-open");
    this.drawer.setAttribute("aria-hidden", "true");
    if (!getActiveInstance()) {
      document.body.classList.remove("sc-nav-open", "sc-nav-active");
    }
    document.removeEventListener("keydown", this._onKeydown);
    if (this._lastFocus && typeof this._lastFocus.focus === "function") {
      try {
        this._lastFocus.focus({ preventScroll: true });
      } catch (e) {
        console.log("Drawer Error", e);
      }
    }
  };

  ScNavDrawer.prototype.toggle = function (trigger) {
    if (this.isOpen) this.close();
    else this.open(trigger);
  };

  ScNavDrawer.prototype._onKeydown = function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== "Tab") return;

    var focusables = Array.prototype.filter.call(
      this.drawer.querySelectorAll(FOCUSABLE),
      function (el) {
        return !el.hasAttribute("disabled") && el.offsetParent !== null;
      },
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  window.customElements.define("sc-nav-drawer", ScNavDrawer);
})();
